import { Component, inject } from '@angular/core';
import { ClientService } from '@core-app/services/client.service';
import { ApiService } from '@gallaghercp/core-frontend';
import { Router } from '@angular/router';
import { CampusService } from '@core-app/services/campus.service';

interface FooterLink {
  text: string;
  url: string;
}
@Component({
  selector: 'core-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false,
})
export class LandingComponent {
  client = inject(ClientService);
  campusService = inject(CampusService);
  protected api = inject(ApiService);
  private router = inject(Router);

  footerLinks: FooterLink[] = [
    { text: 'Contacts', url: 'https://uhsystem.edu/contacts/' },
    {
      text: 'Report Copyright Infringement',
      url: 'https://uhsystem.edu/resources/brand/copyright/',
    },
    { text: 'Texas.gov', url: 'https://www.texas.gov/' },
    {
      text: 'Texas Homeland Security',
      url: 'https://gov.texas.gov/organization/hsgd',
    },
    { text: 'TRAIL', url: 'https://www.tsl.texas.gov/trail/index.html' },
    {
      text: 'Fraud Reporting',
      url: 'https://sao.fraud.texas.gov/ReportFraud/',
    },
    {
      text: 'Fraud & Non-Compliance Hotline',
      url: 'https://www.uhsystem.edu/fraud-non-compliance/',
    },
    {
      text: 'Linking Notice',
      url: 'https://www.sos.state.tx.us/linkpolicy.shtml',
    },
    {
      text: 'Privacy Notice',
      url: 'https://uhsystem.edu/resources/privacy-notice/',
    },
    {
      text: 'Open Records/Public Information Act',
      url: 'https://uhsystem.edu/offices/legal-affairs/general-counsel/public-information-act/',
    },
    {
      text: 'Institutional Résumé',
      url: 'https://apps.highered.texas.gov/resumes/',
    },
    {
      text: 'Required Reports',
      url: 'http://www.uh.edu/finance/pages/State_Report.htm',
    },
    {
      text: 'Electronic & Information Resources Accessibility',
      url: 'https://www.uh.edu/equal-opportunity/eir-accessibility/',
    },
    {
      text: 'Discrimination and Sexual Misconduct Reporting and Awareness',
      url: 'https://www.uh.edu/sexual-misconduct-reporting-form/',
    },
    {
      text: 'UH System Policies',
      url: 'https://uhsystem.edu/resources/compliance-ethics/uhs-policies/',
    },
  ];

  selectCampus(zone: number) {
    localStorage.setItem('selectedCampus', zone.toString());
    this.campusService.setSelectedCampus(zone);
    this.router.navigate(['/']); // Navigate to the homepage
  }
}
